(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaos-financing')) {
    customElements.define('kaos-financing', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.getAttribute('form'));
        this.onVariantChange = this.onVariantChange.bind(this);
        this.form?.addEventListener('variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:change', this.onVariantChange);
      }

      onVariantChange(event) {
        const variant = event.detail?.variant;
        if (!variant) return;

        const affirmMessage = this.querySelector('.affirm-as-low-as');
        if (affirmMessage) affirmMessage.dataset.amount = variant.price;

        if (window.affirm?.ui?.refresh) {
          window.affirm.ui.refresh();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
